import React, { FC, memo, useMemo } from 'react';
import LanguageSetting from 'Component/pages/components/LanguageSetting';
import { AsrFilterConfig } from 'src/api/types';
import { SecondaryTypeMap } from '../../const';
import { isNumber } from 'src/util/core';
import { SelectProps } from 'antd';

interface TemplateProps {
    sourceType: number;
    value?: AsrFilterConfig[];
    onChange?: (v: TemplateProps['value']) => void;
    onSave?: (v: AsrFilterConfig) => void;
    onDelete?: (id?: number) => void;
    disabledList?: number[];
    hasAdaption?: boolean;
    hasASR?: boolean;
    options?: SelectProps<number>['options'];
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        sourceType,
        value,
        onChange,
        onSave,
        onDelete,
        disabledList: _disabledList,
        hasAdaption,
        hasASR,
        options,
    } = props;

    const disabledList = useMemo(() => {
        return [
            ...(_disabledList || []),
            ...(value
                ?.filter((v) => isNumber(v.filter?.languageType))
                ?.map((v) => v.filter!.languageType!) || []),
        ];
    }, [value, _disabledList]);

    return (
        <LanguageSetting
            type={sourceType}
            value={value?.map((v) => {
                return {
                    ...v.filter,
                    languageChangeDisabled: !!v.id,
                };
            })}
            disabledList={disabledList}
            onChange={(v) =>
                onChange?.(
                    v?.map((v, idx) => ({
                        type: 1,
                        sourceType,
                        activeFlag: 1,
                        secondaryType: SecondaryTypeMap.RULES,
                        ...value?.[idx],
                        filter: v,
                    })) || []
                )
            }
            onSave={(idx, v) => {
                const newValue = v?.[idx];
                const oldValue = value?.[idx];

                onSave?.({
                    type: 1,
                    sourceType,
                    activeFlag: 1,
                    secondaryType: SecondaryTypeMap.RULES,
                    ...oldValue,
                    filter: newValue,
                });
            }}
            onDelete={(idx) => {
                const id = value?.[idx]?.id;
                onDelete?.(id);
            }}
            options={options}
            hasAdaption={hasAdaption}
            hasASR={hasASR}
        />
    );
});

export default Template;
